export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE'

export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'auth/LOGOUT_FAILURE'

export const REQUEST_PASSWORD_RESET_REQUEST =
  'auth/REQUEST_PASSWORD_RESET_REQUEST'
export const REQUEST_PASSWORD_RESET_SUCCESS =
  'auth/REQUEST_PASSWORD_RESET_SUCCESS'
export const REQUEST_PASSWORD_RESET_FAILURE =
  'auth/REQUEST_PASSWORD_RESET_FAILURE'

export const PASSWORD_RESET_REQUEST = 'auth/PASSWORD_RESET_REQUEST'
export const PASSWORD_RESET_SUCCESS = 'auth/PASSWORD_RESET_SUCCESS'
export const PASSWORD_RESET_FAILURE = 'auth/REQUEST_PASSWORD_RESET_FAILURE'

export const TWO_FACTO_VERIFICATION_CODE_SENT =
  'auth/TWO_FACTO_VERIFICATION_CODE_SENT'

export const UPDATE_FIELD = 'auth/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'auth/SET_DEFAULT_DATA'
